import React from 'react';
import {Image} from '../../../atoms/Image/Image';
import {ScrollableHorizontalList} from '../../../molecules/ScrollableHorizontalList/ScrollableHorizontalList';

export interface ScreenshotProps {
  images: string[];
  isMobile: boolean;
  onClickImage?: (
    image: string,
    index: number,
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void;
}

export function Screenshot({
  images,
  isMobile,
  onClickImage,
  ...props
}: ScreenshotProps) {
  return (
    <div className="w-full pb-10pxr" {...props}>
      <ScrollableHorizontalList
        isMobile={isMobile}
        hideArrow={true}
        gapPx={4}
        className="pb-8pxr"
        innerLeftPx={18}
        innerRightPx={18}
      >
        {images.map((image, index) => (
          <div
            key={`screenshot-${index}`}
            className="h-[231px] w-[130px] cursor-pointer overflow-hidden rounded-8pxr"
            onClick={e => onClickImage && onClickImage(image, index, e)}
          >
            <Image
              alt="스크린샷"
              src={image}
              ratio={130 / 231}
              className="h-full w-full"
            />
          </div>
        ))}
      </ScrollableHorizontalList>
    </div>
  );
}
